import KeepAlive from "react-activation"
import { useLocation } from "react-router-dom"
import { SActionBtn, SBack, SLowcodeList, SMessage, STableActions } from "shj-components"
import config from './config.json';
import { useRef, useState } from "react";
import { Select, message } from "antd";
import AddAndEdit from "./addAndEdit";
import { evaluationIndexDelete, evaluationIndexList, getRoleList } from "@/services/evaluateConfig";
import { httpDictServ } from "@/services/customerServices";
import {getEnums} from "@/services/homeService";

const EvaluateIndex = () => {
    const listRef = useRef<any>();
    const [detailInfo, setDetailInfo] = useState<any>();
    const [visibleDrawer, setVisibleDrawer] = useState(false);
    const [evaluationServiceTypeList, setEvaluationServiceTypeList] = useState([]);
    const [evaluationDimensionList, setEvaluationDimensionList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [evaluationCategoryList, setEvaluationCategoryList] = useState([]);//评价类别枚举
    const [evaluationCategoryVal, setEvaluationCategoryVal] = useState("");//评价类别val
    const fetchList = (values: any) => {
        return new Promise(async (resolve, reject) => {
            try {
                const { current, pageSize, query, ...rest } = values;
                const  orderBys = [
                    {
                      "columnName": "id",
                      "asc": false
                    }
                ];
                const dataQuery = { queryEvaluationDimensionDesc: true, queryQuestion: true, orderBys, ...query }
                evaluationIndexList(current, pageSize, dataQuery).then(data => {
                    resolve(data)
                })
            } catch (e) {
                reject({ success: false });
            }
        });
    };
    const getStatusOptions = () => {
        return new Promise(async (resolve) => {
            try {
                // 服务类型列表
                const evaluationServiceTypeList: any = await httpDictServ({ parentKey: 'evaluationServiceType', enable: 1, });
                // 评价类别枚举
                const evaluationCategoryEnumList: any = await getEnums("plus-member", "com.shj.saas.plus.member.enums.EvaluationCategoryEnum")
                const evaluationCategoryEnum = evaluationCategoryEnumList.filter(item => item.description != '订单评价');
                // 查询角色列表
                const roleList: any = await getRoleList({
                        "roleType": "SYSTEM",  //只查内置角色
                        "enabled": true   //启用的
                    }
                );
                // 指标维度列表
                const metricsCategoryEnumList: any = await getEnums("plus-member", "com.shj.saas.plus.member.enums.MetricsCategoryEnum")
                setRoleList(roleList);
                setEvaluationServiceTypeList(evaluationServiceTypeList);
                setEvaluationCategoryList(evaluationCategoryEnum);
                resolve({
                    evaluationCategoryEnum,
                    metricsCategoryEnumList,
                });
            } catch (e) { }
        });
    };
    const onAdd = () => {
        setDetailInfo({})
        setVisibleDrawer(true)
    }
    const closeDetails = () => {
        setVisibleDrawer(false)
    }
    const reloadList = () => {
        listRef.current?.reload()
    }
    const onDelete = (id) => {
        const dialog = SMessage.delete({
            onOk: async () => {
                try {
                    const res: any = await evaluationIndexDelete(id)
                    if (res.errorCode === 0) {
                        message.success('删除成功');
                        listRef.current.reload();
                    } else {
                        message.error('删除失败');
                    }
                } catch (err) {
                    console.log(err)
                }
                dialog?.destroy();
            },
            onCancel: () => {
                message.warning('取消删除');
                dialog?.destroy();
            },
        });
    };

    const extension = {
        request: { fetchList, getStatusOptions },
        events: { onAdd },
        searchFormConfig: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        },
        customRender: {
            evaluationServiceTypeRender({ name, form }: any) {
                return (
                    <Select
                        showSearch
                        allowClear
                        filterOption={(input: any, option: any) => {return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;}}
                        onChange={(value) => {
                            form.setFieldsValue({[name]: value,});
                            if( evaluationCategoryVal !== 'userEvaluation'){
                                form?.setFieldValue('evaluationDimension', "");
                            }
                            httpDictServ({ parentKey: value, enable: 1, }).then((res: any) => {
                                setEvaluationDimensionList(res);
                            })
                        }}
                        options={evaluationServiceTypeList || []}
                        fieldNames={{ label: 'name', value: 'priKey' }}
                    />
                );
            },
            evaluationCategoryRender({ name, form }: any) {
                return (
                    <Select
                        showSearch
                        allowClear={true}
                        filterOption={(input: any, option: any) => {
                            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }}
                        onChange={(value) => {
                            form.setFieldsValue({[name]: value,});
                            form?.setFieldValue('evaluationDimension', "");
                            setEvaluationCategoryVal(value)
                        }}
                        options={evaluationCategoryList || []}
                        fieldNames={{ label: 'description', value: 'key' }}
                    />
                );
            },
            evaluationDimensionRender({ name, form }: any) {
                return (
                    <Select
                        showSearch
                        allowClear={true}
                        filterOption={(input: any, option: any) => {
                            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }}
                        onChange={(value) => {form.setFieldsValue({[name]: value,});}}
                        options={evaluationCategoryVal==='userEvaluation'?roleList : evaluationDimensionList}
                        fieldNames={evaluationCategoryVal==='userEvaluation'?{ label: 'name', value: 'code'}:{ label: 'name', value: 'priKey'}}
                    />
                );
            },
            setAction(_text: any, record: any) {
                return <STableActions>
                    <SActionBtn
                        auth={'evalutionIndexEdit'}
                        onClick={() => {
                            setDetailInfo({...record})
                            setVisibleDrawer(true)
                        }}
                    >
                        编辑
                    </SActionBtn>
                    <SActionBtn
                        auth={'evalutionIndexDel'}
                        danger
                        onClick={() => onDelete(record.id)}>
                        删除
                    </SActionBtn>
                </STableActions>;
            },
            labelRender(list: any) {
                return list ? list.join(', ') : ''
            }
        },

    };
    return <>
        <SBack title={`评价指标`}></SBack>
        <SLowcodeList
            config={config}
            ref={listRef} {...extension} searchMode="group" />
        <AddAndEdit record={detailInfo} visibleDrawer={visibleDrawer} closeDetails={closeDetails} reloadList={reloadList}></AddAndEdit>
    </>
}
export default (props: any) => {
    const location = useLocation()
    return (
        <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
            <EvaluateIndex {...props} />
        </KeepAlive>
    )
}
